import { render, staticRenderFns } from "./StatsGlobalesWithTracking.vue?vue&type=template&id=0c4fce0c&"
import script from "./StatsGlobalesWithTracking.vue?vue&type=script&lang=js&"
export * from "./StatsGlobalesWithTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports